import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/index'
}, {
  path: '/index',
  name: 'Index',
  meta: {
    title: '首页',
  },
  component: () => import('../views/Index')
}, {
  path: '/register',
  name: 'UserRegister',
  meta: {
    title: '注册',
    requireAuth: true
  },
  component: () => import('../views/UserRegister')
}, {
  path: '/userinfo',
  name: 'UserInfo',
  meta: {
    title: '用户信息',
    requireAuth: true
  },
  component: () => import('../views/UserInfo')
}, {
  path: '/changephone',
  name: 'ChangePhone',
  meta: {
    title: '更改手机号',
    requireAuth: true
  },
  component: () => import('../views/ChangePhone')
}, {
  path: '/reportlist',
  name: 'ReportList',
  meta: {
    title: '检查报告列表',
    requireAuth: true
  },
  component: () => import('../views/ReportList')
}, {
  path: '/reportdetail',
  name: 'ReportDetail',
  meta: {
    title: '报告详情',
    requireAuth: true
  },
  component: () => import('../views/ReportDetail')
}, {
  path: '/resultlist',
  name: 'ResultList',
  meta: {
    title: '检查结果列表',
    requireAuth: true
  },
  component: () => import('../views/ResultList')
}, {
  path: '/resulttrend',
  name: 'ResultTrend',
  meta: {
    title: '历史趋势',
    requireAuth: true
  },
  component: () => import('../views/ResultTrend')
},{
  path: '/test',
  name: 'Test',
  meta: {
    title: '测试',
    requireAuth: false
  },
  component: () => import('../views/demo')
}]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要初始化
    if (sessionStorage.getItem('logNum')) { // 是否初始化
      next();
    } else {
      next({
        path: '/index' //没有初始化跳转首页去初始化获取openid
      });
    }
  } else {
    next();
  }
})

export default router